import { FeatureKey } from "@/types/generated/FeatureKey";
import type { LoginInfo } from "@/types/LoginInfo";
import { canSeeAtOwnLevel, hasFeatureOrIsPartner } from "@/utils/partnerLevelFeature";

/**
 * Maintenance (STIC-15987, revised) - the two questions every maintenance
 * surface asks, expressed through the shared partner-level rule in
 * {@link partnerLevelFeature}. Kept as named functions because the maintenance
 * call sites read better with them, and so the rule has one home.
 *
 * `hasMaintenanceAccess` mirrors the MAINTENANCE_FEATURE gate of the
 * maintenance resources, `PARTNER || maintenance_basic`, so the UI never offers
 * a path that answers 403. `maintenance_multi_org` is deliberately NOT consulted
 * there: it decides own-level visibility only, see {@link canSeeHomeMaintenance}.
 */
export const hasMaintenanceAccess = (loginInfo?: LoginInfo | null): boolean =>
  hasFeatureOrIsPartner(FeatureKey.maintenance_basic, loginInfo);

/**
 * May this login see maintenance at its OWN level - the HOME menu entries and
 * the own-level admin entry? NORMAL on maintenance_basic, PARTNER on
 * maintenance_multi_org (its aggregated view over the customer orgs it manages;
 * the key MTU holds), SYSTEM never.
 */
export const canSeeHomeMaintenance = (loginInfo?: LoginInfo | null): boolean =>
  canSeeAtOwnLevel(FeatureKey.maintenance_basic, FeatureKey.maintenance_multi_org, loginInfo);

export default hasMaintenanceAccess;
